import { sidebarItemKey } from 'dashboard/constants/sidebarItems';

/**
 * Drops the entries in `disabledKeys` from the sidebar menu tree. A group
 * whose children were all hidden goes away with them; a group that never had
 * children (no teams yet, for instance) is left for the sidebar to handle.
 */
export const filterSidebarItems = (items, disabledKeys, parentKey = '') =>
  items.flatMap(item => {
    const key = sidebarItemKey(item.name, parentKey);
    if (disabledKeys.includes(key)) return [];
    if (!item.children?.length) return [item];

    const children = filterSidebarItems(item.children, disabledKeys, key);
    return children.length ? [{ ...item, children }] : [];
  });
